
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, importProvidersFrom } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import Aura from '@primeng/themes/aura';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { providePrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AppRoutes } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { AlterarSenhaGuard } from './app/auth/alterar-senha/alterar-senha-guard';
import { InscricaoErrorInterceptor } from './app/modules/inscricao-publica/interceptors/inscricao-error.interceptor';
import { TokenInterceptor } from './app/service/core/interceptor.service';

registerLocaleData(localePt, 'pt-BR');

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            ConfirmDialogModule,
            ButtonModule,
            FontAwesomeModule
        ),
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        // { provide: HTTP_INTERCEPTORS, useClass: MockApiInterceptor, multi: true },  // ← MOCK (desativado — backend Java ativo)
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: InscricaoErrorInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: APP_BASE_HREF, useValue: '/' },
        provideRouter(AppRoutes),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        MessageService,
        AlterarSenhaGuard,
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: false || 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'styles, primeng, another-css-library'
                    }
                },
            },
            translation: {
                startsWith: 'Começa com',
                contains: 'Contém',
                notContains: 'Não contém',
                endsWith: 'Termina com',
                equals: 'Igual a',
                notEquals: 'Diferente de',
                noFilter: 'Sem filtro',
                lt: 'Menor que',
                lte: 'Menor ou igual a',
                gt: 'Maior que',
                gte: 'Maior ou igual a',
                is: 'É',
                isNot: 'Não é',
                before: 'Antes',
                after: 'Depois',
                dateIs: 'Data é',
                dateIsNot: 'Data não é',
                dateBefore: 'Data é antes',
                dateAfter: 'Data é depois',
                clear: 'Limpar',
                apply: 'Aplicar',
                matchAll: 'Corresponder a todos',
                matchAny: 'Corresponder a qualquer',
                addRule: 'Adicionar regra',
                removeRule: 'Remover regra',
                accept: 'Sim',
                reject: 'Não',
                choose: 'Escolher',
                completed: 'Concluído',
                upload: 'Enviar',
                cancel: 'Cancelar',
                pending: 'Pendente',
                fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
                dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
                monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                chooseYear: 'Escolher ano',
                chooseMonth: 'Escolher mês',
                chooseDate: 'Escolher data',
                prevDecade: 'Década anterior',
                nextDecade: 'Próxima década',
                prevYear: 'Ano anterior',
                nextYear: 'Próximo ano',
                prevMonth: 'Mês anterior',
                nextMonth: 'Próximo mês',
                prevHour: 'Hora anterior',
                nextHour: 'Próxima hora',
                prevMinute: 'Minuto anterior',
                nextMinute: 'Próximo minuto',
                prevSecond: 'Segundo anterior',
                nextSecond: 'Próximo segundo',
                am: 'AM',
                pm: 'PM',
                dateFormat: 'dd/mm/yy',
                firstDayOfWeek: 0,
                today: 'Hoje',
                weekHeader: 'Sm',
                weak: 'Fraca',
                medium: 'Média',
                strong: 'Forte',
                passwordPrompt: 'Digite uma senha',
                emptyMessage: 'Nenhum resultado encontrado',
                searchMessage: 'Resultados de busca disponíveis',
                selectionMessage: '{0} itens selecionados',
                emptySelectionMessage: 'Nenhum item selecionado',
                emptySearchMessage: 'Nenhum resultado encontrado',
                emptyFilterMessage: 'Nenhum resultado encontrado',
                fileChosenMessage: 'Arquivos',
                noFileChosenMessage: 'Nenhum arquivo selecionado',
                aria: {
                    trueLabel: 'Verdadeiro',
                    falseLabel: 'Falso',
                    nullLabel: 'Não selecionado',
                    star: '1 estrela',
                    stars: '{star} estrelas',
                    selectAll: 'Todos os itens selecionados',
                    unselectAll: 'Todos os itens desmarcados',
                    close: 'Fechar',
                    previous: 'Anterior',
                    next: 'Próximo',
                    navigation: 'Navegação',
                    scrollTop: 'Rolar para o topo',
                    moveTop: 'Mover para o topo',
                    moveUp: 'Mover para cima',
                    moveDown: 'Mover para baixo',
                    moveBottom: 'Mover para o final',
                    moveToTarget: 'Mover para o destino',
                    moveToSource: 'Mover para a origem',
                    moveAllToTarget: 'Mover todos para o destino',
                    moveAllToSource: 'Mover todos para a origem',
                    pageLabel: '{page}',
                    firstPageLabel: 'Primeira página',
                    lastPageLabel: 'Última página',
                    nextPageLabel: 'Próxima página',
                    prevPageLabel: 'Página anterior',
                    rowsPerPageLabel: 'Linhas por página',
                    previousPageLabel: 'Página anterior',
                    jumpToPageDropdownLabel: 'Ir para página',
                    jumpToPageInputLabel: 'Ir para página',
                    selectRow: 'Linha selecionada',
                    unselectRow: 'Linha desmarcada',
                    expandRow: 'Linha expandida',
                    collapseRow: 'Linha recolhida',
                    showFilterMenu: 'Exibir menu de filtro',
                    hideFilterMenu: 'Ocultar menu de filtro',
                    filterOperator: 'Operador de filtro',
                    filterConstraint: 'Restrição de filtro',
                    editRow: 'Editar linha',
                    saveEdit: 'Salvar edição',
                    cancelEdit: 'Cancelar edição',
                    listView: 'Visualização em lista',
                    gridView: 'Visualização em grade',
                    slide: 'Slide',
                    slideNumber: '{slideNumber}',
                    zoomImage: 'Ampliar imagem',
                    zoomIn: 'Aumentar zoom',
                    zoomOut: 'Diminuir zoom',
                    rotateRight: 'Girar para a direita',
                    rotateLeft: 'Girar para a esquerda',
                    listLabel: 'Lista de opções',
                    selectColor: 'Selecionar uma cor',
                    removeLabel: 'Remover',
                    browseFiles: 'Procurar arquivos',
                    maximizeLabel: 'Maximizar',
                    minimizeLabel: 'Minimizar'
                }
            },
        }),
    ],
}).catch((err) => console.error(err));
